// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1HHJQ","content":"LoadingAlert_content__17NOU"};